/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from 'flickity';
require('flickity-imagesloaded');

/*------------------------------------*\
    STALLION CAROUSEL
\*------------------------------------*/
class StallionCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.primaryCarouselElem = self.elem.querySelector('[data-primary-carousel]');

    }

    init() {
        let self = this;
        self.carousel();
    }

    carousel() {
        let self = this;

        self.flkty = new Flickity(self.elem, {
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: false,
            contain: false,
            imagesLoaded: true,
            pageDots: true
            
        });
    }


}

export default StallionCarousel;